module.exports = __webpack_public_path__ + "rw-widgets.svg";